/** @jsx jsx */
/* global AnyNewsletter */
import React from "react";
import { jsx } from "theme-ui";
import { Container } from "@shared-components/Container/Container";
import { useSiteContext } from "../../context/site/useSiteContext";

const EmbedNewsletter: React.FC = () => {
  const { currentCulture, hocFlavourIds } = useSiteContext();

  const setBeerFamilyIds = () => {
    if (hocFlavourIds && hocFlavourIds.length > 0) {
      const beerFamilyInput = document.querySelector(
        '[data-name="beer_family"]'
      ) as HTMLInputElement;

      if (beerFamilyInput) {
        beerFamilyInput.value = hocFlavourIds.toString();
      }
    }
  };

  if (globalThis.document) {
    const script = globalThis.document.createElement("script");
    script.src =
      currentCulture === "da"
        ? "https://carlsberg94216.activehosted.com/f/embed.php?id=13"
        : "https://carlsberg94216.activehosted.com/f/embed.php?id=3";
    script.async = true;
    script.id = "ac-form-script";

    script.onload = () => {
      if (globalThis) {
        //@ts-ignore-next-line
        window._form_callback = (id: string) => {
          // @ts-ignore-next-line
          window.dataLayer.push({
            event: "subscription_confirmed",
            ac_id: currentCulture === "da" ? 13 : 3,
          });
        };
      }

      const pathName = window.location;
      const fields = document.querySelectorAll("._inline-style");
      fields.forEach((field) => {
        field.classList.remove("_inline-style");
      });
      const URLInput = document.querySelector(
        '[data-name="memories_url"]'
      ) as HTMLInputElement;
      if (URLInput) {
        URLInput.value = pathName.toString();
      }

      const privacyPolicyConsent = document.querySelector(
        "#consent_privacy-policy"
      );

      if (privacyPolicyConsent) {
        const privacyPolicyConsentClone = privacyPolicyConsent.cloneNode(true);

        const checkboxLabel = document.querySelector(
          "input[data-name='privacy_policy_consent'] + span label"
        );

        if (checkboxLabel?.textContent) {
          checkboxLabel.textContent = checkboxLabel.textContent.replace(
            "*",
            " "
          );
          checkboxLabel.textContent = checkboxLabel.textContent.replace(
            "consent",
            " "
          );
        }
        const labelParent =
          checkboxLabel?.parentElement?.parentElement?.parentElement
            ?.parentElement;
        if (labelParent) {
          labelParent.classList.add("privacyPolicyConsent");
        }
        checkboxLabel?.append(privacyPolicyConsentClone);
        privacyPolicyConsent.parentElement?.parentElement?.remove();
      }

      const newsletterConsent = document.querySelector("#newsletter_consent");

      if (newsletterConsent) {
        const newsletterConsentClone = newsletterConsent.cloneNode(true);

        const checkboxLabel = document.querySelector(
          "input[data-name='newsletter_consent'] + span label"
        );

        if (checkboxLabel?.textContent) {
          checkboxLabel.textContent = checkboxLabel.textContent.replace(
            "*",
            " "
          );
          checkboxLabel.textContent = checkboxLabel.textContent.replace(
            "consent",
            " "
          );
        }
        const labelParent =
          checkboxLabel?.parentElement?.parentElement?.parentElement
            ?.parentElement;
        if (labelParent) {
          labelParent.classList.add("newsletterConsent");
        }
        checkboxLabel?.append(newsletterConsentClone);
        newsletterConsent.parentElement?.parentElement?.remove();
      }

      const emptyFormElements = document.querySelectorAll(
        "#newsletter_wrapper input[type='hidden'"
      );

      emptyFormElements.forEach((element) => {
        const dataName = element.getAttribute("data-name");
        if (
          dataName === "beer_family" ||
          dataName === "memories_url" ||
          dataName === "utm"
        ) {
          element?.parentElement?.classList.add("emptyFormElement");
        }
      });

      const select = document.querySelector(
        '[data-name="country"]'
      ) as HTMLSelectElement;
      if (select) {
        if (currentCulture === "da") {
          select.options[0].innerText = "Land";
        } else {
          select.options[0].innerText = "Country";
        }
      }
    };

    setBeerFamilyIds();

    const scriptElement = document.getElementById("ac-form-script");
    if (!scriptElement) {
      globalThis.document.body.appendChild(script);
    }
  }

  return (
    <Container id="newsletter">
      <div
        id="newsletter_wrapper"
        className={currentCulture === "da" ? "_form_13" : "_form_3"}
      ></div>
    </Container>
  );
};

export { EmbedNewsletter };
